import { twMerge } from "tailwind-merge";

import { TYPO_STYLES } from "@/styles/typography";
import { WRAPPER_STYLES } from "@/styles/wrapper";

import { LinkView } from "./link.view";

// if n > 5
// [1,3]   [1,2,3,4,0,m]
// [4,m-3] [1,0,n-1,n,n+1,0,m]
// [m-2,m] [1,0,m-3,m-2,m-1,m]
// else
// [1,..,m]
function getPagination(pageCount: number, pageNumber: number): number[] {
    if (pageCount > 0 && pageNumber > 0) {
        if (pageCount > 5) {
            if (pageNumber < 4) {
                return [1, 2, 3, 4, 0, pageCount];
            } else if (pageNumber < pageCount - 2) {
                return [1, 0, pageNumber - 1, pageNumber, pageNumber + 1, 0, pageCount];
            } else {
                return [1, 0, pageCount - 3, pageCount - 2, pageCount - 1, pageCount];
            }
        } else return Array.from({ length: pageCount }, (_, i) => i + 1);
    } else {
        return [];
    }
}

type PaginationProps = {
    getPageURL: (pageNumber: number) => string;
    pageCount: number;
    pageNumber: number;
};
export const PaginationView = ({ pageCount, pageNumber, getPageURL }: PaginationProps) => {
    if (pageCount > 1) {
        return (
            <div className={WRAPPER_STYLES.HCenterCenter()}>
                {pageNumber === 1 ? (
                    <div
                        className={twMerge(
                            WRAPPER_STYLES.HCenterCenter(),
                            "hidden sm:flex px-2 py-2 text-grey6 bg-white",
                        )}
                    >
                        <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                            {String.fromCharCode(Number("0xe907"))}
                        </span>
                    </div>
                ) : (
                    <LinkView
                        href={getPageURL(pageNumber - 1)}
                        prefetch={false}
                        className={twMerge(
                            WRAPPER_STYLES.HCenterCenter(),
                            "hidden sm:flex px-2 py-2 text-brandDark bg-white",
                        )}
                    >
                        <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                            {String.fromCharCode(Number("0xe907"))}
                        </span>
                    </LinkView>
                )}
                {getPagination(pageCount, pageNumber).map((p, i) =>
                    p === 0 ? (
                        <span key={i} className={"px-4 py-2 text-brandDark bg-white"}>
                            ...
                        </span>
                    ) : (
                        <LinkView
                            key={i}
                            prefetch={false}
                            href={getPageURL(p)}
                            className={`px-4 py-2 text-brandDark ${pageNumber === p ? "bg-brandYellow" : "bg-white"}`}
                        >
                            {p}
                        </LinkView>
                    ),
                )}
                {pageNumber === pageCount ? (
                    <div
                        className={twMerge(
                            WRAPPER_STYLES.HCenterCenter(),
                            "hidden sm:flex px-2 py-2 text-grey6 bg-white",
                        )}
                    >
                        <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                            {String.fromCharCode(Number("0xe938"))}
                        </span>
                    </div>
                ) : (
                    <LinkView
                        href={getPageURL(pageNumber + 1)}
                        prefetch={false}
                        className={twMerge(
                            WRAPPER_STYLES.HCenterCenter(),
                            "hidden sm:flex px-2 py-2 text-brandDark bg-white",
                        )}
                    >
                        <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                            {String.fromCharCode(Number("0xe938"))}
                        </span>
                    </LinkView>
                )}
            </div>
        );
    } else {
        return null;
    }
};
